
import { supabase } from "@/integrations/supabase/client";

const DEFAULT_UNIVERSITY = {
  id: 1,
  name: 'UNSW',
  is_active: true,
  campaign_start_date: new Date().toISOString(),
  campaign_end_date: new Date().toISOString(),
  created_at: new Date().toISOString()
};

export const getActiveUniversity = async () => {
  try {
    const { data, error } = await supabase
      .from('universities')
      .select('*')
      .eq('is_active', true)
      .maybeSingle();

    if (error) {
      console.error('Error fetching active university:', error);
      return DEFAULT_UNIVERSITY;
    }

    if (!data) {
      console.warn('No active university found, using default');
      return DEFAULT_UNIVERSITY;
    }

    return {
      ...data,
      name: data.name || DEFAULT_UNIVERSITY.name // Ensure name is never undefined
    };
  } catch (error) {
    console.error('Error in getActiveUniversity:', error);
    return DEFAULT_UNIVERSITY;
  }
};
